import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { Scenario } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';

/**
 * un scenario pour la vision
 */
export class ScenarioVO {
  
  protected _model: Model = null;
  public get model(): Model {
    return this._model as Model;
  }
  public set model(value: Model) {
      this._model = value;
  }

  constructor(model: Model, pSource?: Scenario) {
    this._model = model;
    this._source = null;
    if (pSource) {
      this._source = pSource;
    } else {
      this._source = new Scenario();
      this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau
    }
  }

  /** niveau de profondeur pour rendu de la popUp des scenarii sur globalFilter */
  public level: number = 0;
  /** enfants directs */
  public children: ScenarioVO[] = [];

  /** L'objet source provenant du back */
  protected _source: Scenario;

  public get source(): Scenario {
    return this._source;
  }
  public set source(value: Scenario) {
    this._source = value;
  }

  // code domaine (root), technique
  public get domain(): string {
    return this._source.domain;
  }
  public set domain(value: string) {
    this._source.domain = value;
  }

  public get businessUnitCode(): string {
    // code de la BU
    return this._source.businessUnitCode;
  }
  public set businessUnitCode(value: string) {
    this._source.businessUnitCode = value;
  }

  // Code de la vision
  public set visionCode(visionCode: string) {
    this._source.visionCode = visionCode;
  }
  public get visionCode(): string {
    return this._source.visionCode;
  }

  /**
   * code unique du scnar dans la vision (visionCode + # + UUID)
   */
  public set code(value: string) {
    this._source.code = value;
  }
  public get code(): string {
    return this._source.code;
  }

  public set parentCode(value: string) {
    this._source.parentCode = value;
  }
  public get parentCode(): string {
    return this._source.parentCode;
  }

}
